// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3f3yP","list":"BalanceDue_list__26J8O","listRow":"BalanceDue_listRow__29w4f","total":"BalanceDue_total__M8ido"};